import React from 'react';
import { Box, Card, CardContent, Typography,  } from '@mui/material';
import { Payment as PaymentIcon } from '@mui/icons-material';

const Payments = () => {
  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
        پرداخت‌ها
      </Typography>

      <Card>
        <CardContent sx={{ textAlign: 'center', py: 6 }}>
          <PaymentIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            این بخش در حال توسعه است
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            به زودی امکان مشاهده و مدیریت پرداخت‌ها فعال می‌شود
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Payments;
